// src/components/alert/Alert.js
import React from 'react';
import { createPortal } from 'react-dom';
import { useModalStack } from '../../contexts/geral/ModalStackContext';

const alertStyle = {
  position: 'fixed',
  bottom: window.innerWidth <= 576 ? '10px' : '20px',
  right: window.innerWidth <= 576 ? '10px' : '20px',
  width: window.innerWidth <= 576 ? '90%' : '600px',
  maxWidth: window.innerWidth <= 576 ? 'calc(100% - 20px)' : '600px',
};

const closeButtonStyle = {
  padding: window.innerWidth <= 576 ? '10px' : '5px',
  fontSize: window.innerWidth <= 576 ? '1.2rem' : '1rem',
};

const Alert = ({ show, message, type, onClose }) => {
  const modalLayer = useModalStack(show, 1080, { blocksInteraction: false });

  if (!show) return null;

  return createPortal(
    <div style={{ ...alertStyle, zIndex: modalLayer.zIndex }} data-modal-stack-id={modalLayer.id}>
      <div className={`alert alert-${type} alert-dismissible fade show`} role="alert">
        {message}
        <button
          type="button"
          className="btn-close"
          onClick={onClose}
          aria-label="Close"
          style={closeButtonStyle}
        ></button>
      </div>
    </div>,
    document.body
  );
};

export default Alert;
